import { call } from 'redux-saga/effects';
import removeIncomingCall from '../../callSessions/removeIncomingCall/removeIncomingCall';

export default function* rejectCall({ payload: { call: callSession, signalHid = true } }) {
  callSession.reject(signalHid);
  yield call(removeIncomingCall, { payload: callSession.id });
}
